import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

export const RegistrationPerEventView = ({ data }: any) => {
  const safeData =
    Array.isArray(data) && data.length > 0
      ? data
      : [
        {
          EventName: "No Event",
          TShirtPrinting: 0,
          MedalEngraving: 0,
          Delivery: 0,
          Insurance: 0,
        },
      ];

  const categories = safeData.map((item: any) => item.EventName);

  const series: Highcharts.SeriesColumnOptions[] = [
    {
      name: "T-shirt Printing",
      type: "column",
      data: safeData.map((item: any) => item.TShirtPrinting || 0),
    },
    {
      name: "Medal Engraving",
      type: "column",
      data: safeData.map((item: any) => item.MedalEngraving || 0),
    },
    {
      name: "Delivery",
      type: "column",
      data: safeData.map((item: any) => item.Delivery || 0),
    },
    {
      name: "Insurance",
      type: "column",
      data: safeData.map((item: any) => item.Insurance || 0),
    },
  ];

  const options: Highcharts.Options = {
    chart: { type: "column" },
    title: { text: "Registration Services Per Event" },
    xAxis: {
      categories,
      title: { text: "Event Name",style: { fontSize: "11px", color: "black" } },
      labels: { style: { fontSize: "11px", color: "black" } },
    },
    yAxis: {
      min: 0,
      title: { text: "Total Participants", style: { fontSize: "11px", color: "black" } },
      labels: { style: { fontSize: "11px", color: "black" } },
      stackLabels: {
        enabled: true,
        style: { color: "gray", textOutline: "none" },
        formatter: function (this: any) {
          return this.total === 0 ? "" : this.total;
        },
      },
    } as any,
    credits: { enabled: false },
    // tooltip: {
    //   shared: true,
    //   formatter: function (this: any) {
    //     return `${this.series.name}: ${this.y === 0 ? "" : this.y}`;
    //   },
    // },
    plotOptions: {
      column: {
        stacking: "normal",
        dataLabels: {
          enabled: true,
          style: { textOutline: "none" },
          formatter: function () {
            return this.y === 0 ? "" : this.y;
          },
        },
      },
    },
    colors: ["#FFD700", "#90EE90", "#FF6347", "#1E90FF"],
    series,
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};
